import React from 'react';

/**
 * Shared SVG clipPath definition used for loading skeletons in BinSetStatusCard components
 * This SVG defines the clip path for bin set loading icons
 */
function BinSetLoadingSVG() {
  return (
    <svg width="0" height="0">
      <defs>
        <clipPath id="bin-set-loading-icon">
          <rect x="55.3354" y="41.5121" width="6.97688" height="5.17353" />
          <path d="M55.3333 72.2395L41.7986 101.07H14.6319L1 72.2395V13.2071H55.3333V72.2395Z" />
          <path d="M116.692 72.2395L103.157 101.07H75.9908L62.3589 72.2395V13.2071H116.692V72.2395Z" />
          <path d="M35.8938 3.59686H20.4395L1 13.1962H55.3333L35.8938 3.59686Z" />
          <path d="M97.2527 3.59686H81.7983L62.3589 13.1962H116.692L97.2527 3.59686Z" />
          <path d="M34.2949 1H22.0372C21.1408 1 20.4172 1.72346 20.4172 2.61969V3.6347H35.9148V2.61969C35.9148 1.72346 35.1912 1 34.2949 1Z" />
          <path d="M95.6537 1H83.3961C82.4997 1 81.7761 1.72346 81.7761 2.61969V3.6347H97.2737V2.61969C97.2737 1.72346 96.5501 1 95.6537 1Z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BinSetLoadingSVG;
